import { render, staticRenderFns } from "./Train.vue?vue&type=template&id=36e3a3ac&scoped=true&"
import script from "./Train.vue?vue&type=script&lang=ts&"
export * from "./Train.vue?vue&type=script&lang=ts&"
import style0 from "./Train.vue?vue&type=style&index=0&id=36e3a3ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e3a3ac",
  null
  
)

export default component.exports